import React from 'react';

import {
  Grid,
  Button,
} from '@material-ui/core';
import NextIcon from '@material-ui/icons/ChevronRight';
import PrevIcon from '@material-ui/icons/ChevronLeft';

import InputField from '../../common/components/inputField';

import classes from '../../css/getCSS';


const referenceInfoForm = (props) => {
  let buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Update
    </Button>
  );

  if (!props.editMode) {
    buttons = (
      <React.Fragment>
        <Button onClick={() => props.redirectToStep(props.prevStep)} variant="contained" color="primary" size="large" className={classes.Button} style={{ marginRight: '10px' }}>
          <PrevIcon />
          Back
        </Button>
        <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
          Next
          <NextIcon />
        </Button>
      </React.Fragment>
    );
  }

  let blockquote = null;

  if (!props.editMode) {
    blockquote = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
          You need a reference to approve your profile
        </blockquote>
        <br /><br />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {blockquote}
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="name"
            config={props.inputs.name}
            changed={event => props.inputChangedHandler(event, 'name')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="phone"
            config={props.inputs.phone}
            changed={event => props.inputChangedHandler(event, 'phone')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="place"
            config={props.inputs.place}
            changed={event => props.inputChangedHandler(event, 'place')}
          />
        </Grid>
      </Grid>
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default referenceInfoForm;



// WEBPACK FOOTER //
// ./src/profile/components/ReferenceInfoForm.js